import { Component, Input, OnInit } from '@angular/core';
import { QuoteRequestState } from '@app/shared';

@Component({
  selector: 'app-youre-done-card',
  templateUrl: './youre-done-card.component.html',
  styleUrls: ['./youre-done-card.component.scss'],
})
export class YoureDoneCardComponent implements OnInit {
  @Input() public quoteRequestState: QuoteRequestState;
  @Input() public youreDoneData: any;

  @Input() public title: string;
  @Input() public outcomeImageSrc: string;
  @Input() public hideDocuments: boolean;

  constructor() {}

  ngOnInit(): void {}
}
